module.exports = __webpack_public_path__ + "static/img/clpp-logo-white.c73170a3.png";